import * as React from 'react';

import { Stack } from '@mui/material';

import Step from './Step';

type StepperProps = {
  activeStep: number;
};

const LIST = ['Product details', 'Requirements', 'Shipping availability'];

const Stepper: React.FC<StepperProps> = ({ activeStep }) => {
  return (
    <Stack direction='row' spacing={1} sx={{ width: '100%', marginBottom: '50px' }}>
      {LIST.map((x, i) => (
        <Step key={i} title={x} active={activeStep === i} />
      ))}
    </Stack>
  );
};

export default Stepper;
